module.exports = __webpack_public_path__ + "img/Dokumentbevakningen_v3-colored.e0827cf2.png";